export default __webpack_public_path__ + "static/media/ema.7d40dbea.png";